import React from 'react';

// eslint-disable-next-line react/prop-types
const SimpleHeaderCell = ({ children }) => {
  return (
    <div>
      <div className="cs-header-cell">{children}</div>
    </div>
  );
};

export default SimpleHeaderCell;
